export default {
    page: function() {
        this.loadOrders()
    },

    'searchParams.futureTrips': function() {
        if (this.searchParams.futureTrips) {
            this.searchParams.pastTrips = false
        }
    },

    'searchParams.pastTrips': function() {
        if (this.searchParams.pastTrips) {
            this.searchParams.futureTrips = false
        }
    }
}
